import { type FC, useId } from 'react';
import type { DeleteConfirmationProps } from '../../types';

const DeleteConfirmation: FC<DeleteConfirmationProps> = ({
  meetingTitle,
  isProcessing,
  onCancel,
  onConfirm,
}) => {
  const headingId = useId();
  return (
    <div
      className="personal-meetings-modal__confirm"
      role="dialog"
      aria-modal="true"
      aria-labelledby={headingId}
    >
      <div className="personal-meetings-modal__confirm-content">
        <h3 id={headingId}>Delete Personal Meeting</h3>
        <p>
          Are you sure you want to delete <strong>{meetingTitle}</strong>? This action cannot be
          undone.
        </p>
        <div className="personal-meetings-modal__confirm-actions">
          <button
            type="button"
            onClick={onCancel}
            className="personal-meetings-modal__confirm-cancel"
            disabled={isProcessing}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="personal-meetings-modal__confirm-delete"
            disabled={isProcessing}
          >
            {isProcessing ? 'Deleting…' : 'Delete'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmation;
